import { render, staticRenderFns } from "./PluginIndexSort.vue?vue&type=template&id=32025476"
import script from "./PluginIndexSort.vue?vue&type=script&lang=js"
export * from "./PluginIndexSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports